import { CLIENT_DATA, PATH, APP_STATUS_MAPPING } from 'shared/constants';
/* eslint-disable import/prefer-default-export */
import ACTION_TYPE from 'shared/constants/actionTypes';

import { defaultClient } from 'shared/context/store';
import { errorMessage, clearAllToast } from 'utils/ErrorHandler';
import {
  LoginAuth, TwoFactorAuth, getDashboardData, getApplicantById, updateApplicant, resendOTP, getFilePdf,
  getPDFSimulation, generateOtp, getApplicantDetailById, getApplicantMoStatus, postApplicantMoStatus, saveAssetAllocationPdf,
  getDashboardUserById, updateApplicantInfo, saveCivilIDAndPassport, getUploadedCustomFiles, getCustomfileByName, deleteCustomfileByName,
  toggleCRN,
  getInitOptions,
  getIntl,
  saveCustomSubPortfolioPdf, validateToken,
  logout,
} from 'shared/services/api';

const AUTH_URL = process.env.REACT_APP_AUTH;
const AUTH_APP_NAME = process.env.REACT_APP_AUTH_APP_NAME;

export const updateClientData = (data) => (dispatch) => {
  clearAllToast();
  dispatch({
    type: ACTION_TYPE.UPDATE_CLIENT_DATA,
    payload: {
      key: data.key,
      value: data.value,
    },
  });
};

export const clearClientData = (token) => async (dispatch) => {
  try {
    const ssoLogoutResp = await logout(token);
    // const res = await requestInvalidateToken(token);
    if (ssoLogoutResp.data === 'true') {
      dispatch({
        type: ACTION_TYPE.CLEAR_CLIENT_DATA,
        payload: defaultClient,
      });
      window.location.replace('/');
    } else {
      dispatch({
        type: ACTION_TYPE.CLEAR_CLIENT_DATA,
        payload: defaultClient,
      });
      // window.location.replace(`${AUTH_URL}/sso/checkpoint/logout?redirectUrl=${origin}`);
      window.location.replace(`${AUTH_URL}/sso/checkpoint/logout?appName=${AUTH_APP_NAME}&redirectUrl=${AUTH_URL}/sso?redirectUrl=${origin}`);
    }
  } catch (err) {
    console.error(err);
  }
};

export const onValidateToken = (token) => async (dispatch) => {
  try {
    const result = await validateToken(token);
    if (!result?.data) {
      await dispatch({
        type: ACTION_TYPE.CLEAR_CLIENT_DATA,
        payload: defaultClient,
      });
      window.open('/', '_self');
    }
  } catch (err) {
    console.error(err);
    if (err.response?.status === 403 || err) {
      dispatch({
        type: ACTION_TYPE.CLEAR_CLIENT_DATA,
        payload: defaultClient,
      });
      window.open('/', '_self');
    }
  }
};

const parseJwt = (token) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(window.atob(base64).split('').map((c) => (`%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`)).join(''));
  return JSON.parse(jsonPayload);
};

export const handleToken = (token) => async (dispatch) => {
  try {
    const result = await validateToken(token);
    if (result) {
      const data = parseJwt(token);
      const clientStorage = [
        { key: CLIENT_DATA.EMAIL, value: data.sub },
        { key: CLIENT_DATA.PHONE, value: data.phone },
        { key: CLIENT_DATA.TOKEN, value: token },
      ];
      // eslint-disable-next-line no-restricted-syntax
      for (const item of clientStorage) {
        updateClientData({ key: item.key, value: item.value })(dispatch);
      }
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};

export const handleLogin = (body, history) => async (dispatch) => {
  const { email, password } = body;
  let errorMess = '';
  clearAllToast();
  try {
    if (!(email && password)) {
      errorMess = `${!email ? 'Email' : ''}${(!email && !password) ? '/' : ''}${!password ? 'Password' : ''} is required`;
      throw new Error();
    }
    await LoginAuth({ username: email, password })
      .then(({ data }) => {
        const clientStorage = [
          { key: CLIENT_DATA.EMAIL, value: email },
          { key: CLIENT_DATA.PHONE, value: data.phone },
          { key: CLIENT_DATA.SESSION, value: data.session },
        ];
        // eslint-disable-next-line no-restricted-syntax
        for (const item of clientStorage) {
          updateClientData({ key: item.key, value: item.value })(dispatch);
        }
        history.push(PATH.OTP);
      }).catch(({ response }) => {
        errorMess = response.data;
        throw new Error();
      });
  } catch (error) {
    errorMessage(errorMess || 'Invalid Email/Password');
  }
};

export const handleOTP = (otp, history) => async (dispatch, state) => {
  const { clientData: { session } } = state.rootState;
  clearAllToast();
  TwoFactorAuth(otp, session).then(({ data }) => {
    updateClientData({ key: CLIENT_DATA.TOKEN, value: data })(dispatch);
    history.push(PATH.DASHBOARD);
  }).catch(() => {
    errorMessage('Invalid OTP');
  });
};

export const handleResendOTP = () => async (dispatch, state) => {
  const { clientData: { session } } = state.rootState;
  const res = await resendOTP(session);
  await updateClientData({ key: CLIENT_DATA.SESSION, value: res.data.session })(dispatch);
  return res;
};

export const getDashboardSummary = () => async (dispatch, state) => {
  const { clientData: { token } } = state.rootState;
  try {
    const res = await getDashboardData(token);
    dispatch({
      type: ACTION_TYPE.GET_DASHBOARD_SUMMARY,
      payload: res.data.content,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const getLanguage = () => async (dispatch, state) => {
  const { clientData: { token } } = state.rootState;
  try {
    const i18nOption = await getInitOptions(token);
    const i18n = await getIntl(token);
    dispatch({
      type: ACTION_TYPE.GET_LANGUAGE,
      payload: { options: i18nOption, languages: i18n },
    });
    // return res;
  } catch (error) {
    return error;
  }
};

export const getApplicantTimeStamp = (id) => async (dispatch, state) => {
  const { clientData: { token } } = state.rootState;
  try {
    const res = await getApplicantById(id, token);
    return res.data;
  } catch (error) {
    return error;
  }
};

export const selectItem = (id = '') => async (dispatch, state) => {
  const { dashboard } = state;
  const summary = await dashboard.summary.map((item) => ({
    ...item,
    isChecked: item.id === id ? !item.isChecked : false,
  }));
  const detail = await summary.find((item) => item.isChecked) || {};

  await dispatch({
    type: ACTION_TYPE.SELECT_ITEM,
    payload: {
      summary,
      detail,
    },
  });
};

// previously we refresh data when user choose a row. However, there is a case when user already tick a arrow
// then data is changed before user open popup -> the data in the popup will be inconsistent
// therefor, we reload data when user open pop up

// export const resetItem = () => async (dispatch, state) => {
//   const { dashboard } = state;
//   const { clientData: { token } } = state.rootState;
//   const { detail } = state.dashboard;
//   if(!detail){
//     return
//   }
//   try {

//     let clonedSummary = JSON.parse(JSON.stringify(dashboard.summary));
//     let currentChoosenId =detail.id
//     let clonedDetail = await clonedSummary.find((item) => item.id === currentChoosenId);

//       const rs = await getDashboardUserById(token, currentChoosenId);
//       clonedSummary = await clonedSummary.map((item) => {
//         if (item.id ===  currentChoosenId) {
//           item = rs.data;
//           item.isChecked = true;
//           clonedDetail = item;
//         }
//         return item;
//       }
//       );

//     await dispatch({
//       type: ACTION_TYPE.SELECT_ITEM,
//       payload: {
//         summary: clonedSummary,
//         detail: clonedDetail,
//       },
//     });

//   } catch (e) {
//     console.log(e)
//   }

// };

export const resetItem = () => async (dispatch, state) => {
  const { dashboard } = state;
  const { clientData: { token } } = state.rootState;
  const { detail } = state.dashboard;
  if (!detail) {
    return;
  }
  try {
    let clonedSummary = JSON.parse(JSON.stringify(dashboard.summary));
    const currentChoosenId = detail.id;
    let clonedDetail = await clonedSummary.find((item) => item.id === currentChoosenId);

    const rs = await getDashboardUserById(token, currentChoosenId);
    clonedSummary = await clonedSummary.map((item) => {
      if (item.id === currentChoosenId) {
        item = rs.data;
        item.isChecked = true;
        clonedDetail = item;
      }
      return item;
    });

    await dispatch({
      type: ACTION_TYPE.SELECT_ITEM,
      payload: {
        summary: clonedSummary,
        detail: clonedDetail,
      },
    });
  } catch (e) {
    console.log(e);
  }
};

export const updateApplicantStatus = (data) => async (dispatch, state) => {
  const { clientData: { token } } = state.rootState;
  const body = {
    clientBeneficiary: '',
    comment: '',
    status: '',
    vestioId: '',
    ...data,
    statusName: data.status ? APP_STATUS_MAPPING[data.status] : '',
  };
  const res = await updateApplicant(body, token);
  await getDashboardSummary()(dispatch, state);
  return res;
};

export const getFilePdfAction = (pdfUrl, name, principal, lang) => async (dispatch, state) => {
  const finalUrl = pdfUrl.replace('{phone}', principal).replace('{lang}', lang === 'AR' ? '-ar' : '');
  const { clientData: { token } } = state.rootState;
  try {
    const file = await getFilePdf(finalUrl, token);

    const url = window.URL.createObjectURL(new Blob([file.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${name}.pdf`); // or any other extension
    document.body.appendChild(link);
    link.click();

    console.log('filefile', file);
  } catch (error) {
    return error;
  }
};

export const getImageAction = (imgUrl, name, phone) => async (dispatch, state) => {
  const finalUrl = imgUrl.replace('{phone}', phone);
  const { clientData: { token } } = state.rootState;
  try {
    const file = await getFilePdf(finalUrl, token);
    let fileType = 'png';
    if (file.headers['content-type'] === 'application/pdf') {
      fileType = 'pdf';
    }
    const url = window.URL.createObjectURL(new Blob([file.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${name}.${fileType}`);
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    return error;
  }
};

export const getExcelAction = (excelUrl, name, phone) => async (dispatch, state) => {
  const finalUrl = excelUrl.replace('{phone}', phone);
  const { clientData: { token } } = state.rootState;
  try {
    const file = await getFilePdf(finalUrl, token);
    const url = window.URL.createObjectURL(new Blob([file.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${name}.xlsx`);
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    return error;
  }
};

export const getPDFSimulationAction = (refCode, name) => async (dispatch, state) => {
  try {
    const file = await getPDFSimulation(refCode);
    const url = window.URL.createObjectURL(new Blob([file.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${name}.pdf`);
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    return error;
  }
};

export const generateOtpAction = (phone) => async (dispatch, state) => {
  const { clientData: { token } } = state.rootState;
  try {
    const res = await generateOtp(phone, token);
    return res.data.otp;
  } catch (error) {
    errorMessage('Could not generate OTP');
  }
};

export const applicantDetailById = (id) => async (dispatch, state) => {
  const { clientData: { token } } = state.rootState;

  try {
    const res = await getApplicantDetailById(id, token);
    return res.data;
  } catch (error) {
    return error;
  }
};

export const applicantMoStatus = (id) => async (dispatch, state) => {
  const { clientData: { token } } = state.rootState;
  try {
    const res = await getApplicantMoStatus(id, token);
    return res.data;
  } catch (error) {
    return error;
  }
};

export const saveApplicantMoStatus = (id, data) => async (dispatch, state) => {
  const { clientData: { token } } = state.rootState;
  try {
    const res = await postApplicantMoStatus(id, token, data);
    return res.data;
  } catch (error) {
    return error;
  }
};

export const saveApplicantData = (id, data) => async (dispatch, state) => {
  const { clientData: { token } } = state.rootState;
  try {
    const res = await updateApplicantInfo(id, token, data);
    return res.data;
  } catch (error) {
    return error;
  }
};

export const getUploadedCustomFilesAction = () => async (dispatch, state) => {
  const { clientData: { token } } = state.rootState;
  const { detail: { id } } = state.dashboard;
  try {
    const res = await getUploadedCustomFiles(id, token);
    return res.data;
  } catch (error) {
    return error;
  }
};

export const uploadCustomSubPfPDF = (file) => async (dispatch, state) => {
  const { clientData: { token } } = state.rootState;
  const { detail: { id } } = state.dashboard;

  try {
    const bodyFormData = new FormData();
    bodyFormData.append('fileupload', file);

    const res = await saveCustomSubPortfolioPdf(id, token, bodyFormData);

    if (res) {
      const { dashboard } = state;
      if (dashboard && dashboard.summary) {
        const clonedSummary = JSON.parse(JSON.stringify(dashboard.summary));
        const detail = await clonedSummary.find((item) => item.id === id) || {};

        if (detail) {
          detail.customSubPfAvailable = true;
          dispatch({
            type: ACTION_TYPE.SELECT_ITEM,
            payload: {
              detail,
              summary: clonedSummary,
            },
          });
        }
      }
    }
    return res.data;
  } catch (error) {
    return error;
  }
};

export const uploadAssetAllocationPDF = (file) => async (dispatch, state) => {
  const { clientData: { token } } = state.rootState;
  const { detail: { id } } = state.dashboard;

  try {
    // const base64File = await toBase64(file);
    const bodyFormData = new FormData();
    bodyFormData.append('uploadfile', file);
    // const res = await saveAssetAllocationPdf(id, token, base64File);
    console.log('bodyFormData', bodyFormData);
    const res = await saveAssetAllocationPdf(id, token, bodyFormData);

    if (res) {
      const { dashboard } = state;
      if (dashboard && dashboard.summary) {
        const clonedSummary = JSON.parse(JSON.stringify(dashboard.summary));
        const detail = await clonedSummary.find((item) => item.id === id) || {};

        if (detail) {
          detail.assetAllocationAvailable = true;
          dispatch({
            type: ACTION_TYPE.SELECT_ITEM,
            payload: {
              detail,
              summary: clonedSummary,
            },
          });
        }
      }
    }
    return res.data;
  } catch (error) {
    return error;
  }
};

export const uploadPassportAndCivilID = (file, type, callBack) => async (dispatch, state) => {
  const { clientData: { token } } = state.rootState;
  const { detail: { id } } = state.dashboard;

  try {
    // const base64File = await toBase64(file);
    const bodyFormData = new FormData();
    bodyFormData.append('fileupload', file);
    // const res = await saveAssetAllocationPdf(id, token, base64File);
    const res = await saveCivilIDAndPassport(id, token, bodyFormData, type);

    if (res) {
      callBack();
    }
    return res.data;
  } catch (error) {
    return error;
  }
};

export const toggleCRNAction = (isRequired) => async (dispatch, state) => {
  const { detail: { id } } = state.dashboard;
  try {
    const { dashboard } = state;
    if (dashboard && dashboard.summary) {
      const clonedSummary = JSON.parse(JSON.stringify(dashboard.summary));
      const detail = clonedSummary.find((item) => item.id === id) || {};
      if (detail) {
        detail.customCrn = isRequired;
        dispatch({
          type: ACTION_TYPE.SELECT_ITEM,
          payload: {
            detail,
            summary: clonedSummary,
          },
        });
      }
    }
  } catch (error) {
    return error;
  }
};
export const toggleCRNActionWithApi = (isRequired) => async (dispatch, state) => {
  const { clientData: { token } } = state.rootState;
  const { detail: { id } } = state.dashboard;

  try {
    const res = await toggleCRN(id, token, isRequired);
    if (res) {
      toggleCRNAction(isRequired)(dispatch, state);
    }
    return res.data;
  } catch (error) {
    return error;
  }
};

export const getCustomfileByNameAction = (name) => async (dispatch, state) => {
  const { clientData: { token } } = state.rootState;
  const { detail: { id } } = state.dashboard;

  try {
    const res = await getCustomfileByName(id, token, name);

    return res.data;
  } catch (error) {
    return error;
  }
};

export const deleteCustomfileByNameAction = (name) => async (dispatch, state) => {
  const { clientData: { token } } = state.rootState;
  const { detail: { id } } = state.dashboard;

  try {
    const res = await deleteCustomfileByName(id, token, name);

    return res.data;
  } catch (error) {
    return error;
  }
};

// const toBase64 = (file) => new Promise((resolve, reject) => {
//   const reader = new FileReader();
//   reader.readAsDataURL(file);
//   reader.onload = () => {
//     let rs = reader.result as string;
//     rs = rs.replace('data:application/pdf;base64,', '');
//     resolve(rs);
//   };
//   reader.onerror = (error) => reject(error);
// });
